module.exports = __webpack_public_path__ + "static/media/QR.d34437e1.png";